import React from "react";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import { DicVal } from "../../modules/appLibrary";

function normalizeSangenDisplayString(value) {
    return String(value ?? "").trim();
}

function formatSangenCodeName(code, name) {
    const normalizedCode = normalizeSangenDisplayString(code);
    const normalizedName = normalizeSangenDisplayString(name);
    if (normalizedCode === "") return normalizedName;
    if (normalizedName === "") return normalizedCode;
    return normalizedCode + ":" + normalizedName;
}

export default function SangenDisplayDialog({ open, loading, header, sizes, rows, onClose }) {
    if (!open) return null;
    const displayHeader = header && typeof header === "object" ? header : {};
    const displaySizes = Array.isArray(sizes) ? sizes : [];
    const displayRows = Array.isArray(rows) ? rows : [];
    const headerFields = [
        { label: "PS品番", value: DicVal(displayHeader, "oppiCd", "") },
        { label: "ブランド品番", value: DicVal(displayHeader, "syohinCd", "") },
        { label: "先方品番", value: DicVal(displayHeader, "makerHinban", "") },
        { label: "ブランドサブアイテム", value: formatSangenCodeName(DicVal(displayHeader, "itemCd", ""), DicVal(displayHeader, "itemName", "")) },
        { label: "サイズパターン", value: formatSangenCodeName(DicVal(displayHeader, "sizePattern", ""), DicVal(displayHeader, "sizePatternName", "")) },
        { label: "サイズ展開コード", value: DicVal(displayHeader, "tenkaiCode", "") }
    ];

    return (
        <div className="kakousiji-dialog" onClick={onClose}>
            <Paper elevation={3} className="kakousiji-dialog__paper kakousiji-sangen-dialog" onClick={(e) => e.stopPropagation()}>
                <div className="kakousiji-sangen-dialog__title-row">
                    <div className="kakousiji-dialog__title kakousiji-sangen-dialog__title">三元表記表示</div>
                    <Button type="button" size="small" variant="contained" className="kakousiji-button kakousiji-button--primary" onClick={onClose}>閉じる</Button>
                </div>
                <div className="kakousiji-sangen-dialog__header-grid">
                    {headerFields.map((field) => (
                        <div key={field.label} className="kakousiji-sangen-dialog__header-field">
                            <div className="kakousiji-sangen-dialog__header-label">{field.label}</div>
                            <div className="kakousiji-sangen-dialog__header-value" title={normalizeSangenDisplayString(field.value)}>{field.value}</div>
                        </div>
                    ))}
                </div>
                <div className="kakousiji-dialog__table-wrap kakousiji-sangen-dialog__table-wrap">
                    {loading ? (
                        <div className="kakousiji-sangen-dialog__message">取得中です。</div>
                    ) : displayRows.length === 0 || displaySizes.length === 0 ? (
                        <div className="kakousiji-sangen-dialog__message">該当データが存在しません。</div>
                    ) : (
                        <table className="kakousiji-dialog__table kakousiji-sangen-dialog__table">
                            <thead>
                                <tr>
                                    <th className="kakousiji-dialog__head-cell kakousiji-sangen-dialog__no-cell">No</th>
                                    <th className="kakousiji-dialog__head-cell kakousiji-sangen-dialog__label-cell">ラベル＼サイズ</th>
                                    {displaySizes.map((size, index) => {
                                        const sizeCd = normalizeSangenDisplayString(DicVal(size, "sizeCd", ""));
                                        const sizeName = normalizeSangenDisplayString(DicVal(size, "sizeName", ""));
                                        return <th key={"sangen_size_" + sizeCd + "_" + index} className="kakousiji-dialog__head-cell kakousiji-sangen-dialog__value-cell">{sizeName || sizeCd}</th>;
                                    })}
                                </tr>
                            </thead>
                            <tbody>
                                {displayRows.map((row, rowIndex) => {
                                    const values = Array.isArray(DicVal(row, "values", [])) ? DicVal(row, "values", []) : [];
                                    return (
                                        <tr key={"sangen_row_" + rowIndex}>
                                            <td className="kakousiji-dialog__body-cell kakousiji-sangen-dialog__no-cell">{rowIndex + 1}</td>
                                            <td className="kakousiji-dialog__body-cell kakousiji-sangen-dialog__label-cell">{DicVal(row, "label", "")}</td>
                                            {displaySizes.map((size, sizeIndex) => (
                                                <td key={"sangen_value_" + rowIndex + "_" + sizeIndex} className="kakousiji-dialog__body-cell kakousiji-sangen-dialog__value-cell">{normalizeSangenDisplayString(values[sizeIndex])}</td>
                                            ))}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                    )}
                </div>
            </Paper>
        </div>
    );
}
